export default class CompanyLatestInvoiceNumber {
	constructor(year, latestInvoiceNr, suggestedNextInvoiceNr) {
		this.year = parseInt(year, 10);
		this.latestInvoiceNr = latestInvoiceNr;
		this.suggestedNextInvoiceNr = suggestedNextInvoiceNr;
	}
}
